export const G_TAG = {
  ROOT_DATA_LAYER: "RootdomainDataLayer",
  SUBDOMAIN_DATA_LAYER: "SubdomainDataLayer",
};

export const GOOGLE_ADS_CONVERSION_ID_INDIA =
  process.env.GOOGLE_ADS_CONVERSION_ID_INDIA;

// export const GOOGLE_ADS_CONVERSION_ID_ABROAD =
//   process.env.GOOGLE_ADS_CONVERSION_ID_ABROAD;

export const GOOGLE_ADS_CONVERSION_LABEL_INDIA =
  process.env.GOOGLE_ADS_CONVERSION_LABEL_INDIA;
